import { cpf, cnpj } from 'cpf-cnpj-validator';

function normalizeCNPJ(document) {
  return String(document || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}

function getCNPJCharacterValue(character) {
  return character.charCodeAt(0) - 48;
}

function calculateCNPJDigit(base, weights) {
  const sum = base
    .split('')
    .reduce((total, character, index) => total + getCNPJCharacterValue(character) * weights[index], 0);
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

function checkIfAlphanumericCNPJIsValid(document) {
  const normalized = normalizeCNPJ(document);

  if (!/^[A-Z0-9]{12}\d{2}$/.test(normalized)) return false;
  if (/^([A-Z0-9])\1{13}$/.test(normalized)) return false;

  const firstDigit = calculateCNPJDigit(normalized.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const secondDigit = calculateCNPJDigit(
    `${normalized.slice(0, 12)}${firstDigit}`,
    [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2],
  );

  return normalized.endsWith(`${firstDigit}${secondDigit}`);
}

export function checkIfCPFIsValid(document) {
  const valid = cpf.isValid(document);
  return valid;
}

export function checkIfCNPJIsValid(document) {
  if (cnpj.isValid(document)) return true;
  return checkIfAlphanumericCNPJIsValid(document);
}
